import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MessageCircle, MapPin, Mail, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Footer() {
  return <footer className="bg-[#2C2C2C] text-[#FAF7F2] pt-16 pb-8" data-id="element-34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-36">
          {/* Brand Column */}
          <div className="col-span-1 md:col-span-1" data-id="element-37">
            <Link to="/" className="inline-block mb-6" data-id="element-38">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/p7F7UJfUdiT9HJFSan1U4Z/Oshara_Collective_Logo.png" alt="Oshara Collective" className="h-16 w-auto brightness-0 invert" data-id="element-39" />
            </Link>
            <p className="text-[#FAF7F2]/70 text-sm leading-relaxed mb-6" data-id="element-40">
              Experience peaceful living in the heart of Kochi. Luxury
              accommodations designed for the modern traveler.
            </p>
            <div className="flex space-x-4" data-id="element-41">
              <a href="#" className="text-[#FAF7F2]/70 hover:text-[#D4AF37] transition-colors" data-id="element-42">
                <Instagram className="h-5 w-5" data-id="element-43" />
                <span className="sr-only" data-id="element-44">Instagram</span>
              </a>
              <a href="https://wa.me/919746603446" target="_blank" rel="noopener noreferrer" className="text-[#FAF7F2]/70 hover:text-[#D4AF37] transition-colors" data-id="element-45">
                <MessageCircle className="h-5 w-5" data-id="element-46" />
                <span className="sr-only" data-id="element-47">WhatsApp</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-48">
            <h3 className="font-serif text-lg font-medium mb-6 text-[#D4AF37]" data-id="element-49">
              Explore
            </h3>
            <ul className="space-y-4" data-id="element-50">
              <li data-id="element-51">
                <Link to="/collections" className="text-[#FAF7F2]/70 hover:text-[#FAF7F2] transition-colors text-sm" data-id="element-52">
                  Our Collections
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/kochi-guide" className="text-[#FAF7F2]/70 hover:text-[#FAF7F2] transition-colors text-sm" data-id="element-54">
                  Kochi Guide
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/" className="text-[#FAF7F2]/70 hover:text-[#FAF7F2] transition-colors text-sm" data-id="element-56">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-57">
            <h3 className="font-serif text-lg font-medium mb-6 text-[#D4AF37]" data-id="element-58">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-59">
              <li className="flex items-start space-x-3 text-[#FAF7F2]/70 text-sm" data-id="element-60">
                <MapPin className="h-5 w-5 shrink-0 text-[#8B7355]" data-id="element-61" />
                <span data-id="element-62">Maradu, Kochi, Kerala, India 682304</span>
              </li>
              <li className="flex items-center space-x-3 text-[#FAF7F2]/70 text-sm" data-id="element-63">
                <Phone className="h-5 w-5 shrink-0 text-[#8B7355]" data-id="element-64" />
                <a href="tel:+919746603446" className="hover:text-[#FAF7F2] transition-colors" data-id="element-65">
                  +91 97466 03446
                </a>
              </li>
              <li className="flex items-center space-x-3 text-[#FAF7F2]/70 text-sm" data-id="element-66">
                <Mail className="h-5 w-5 shrink-0 text-[#8B7355]" data-id="element-67" />
                <a href="mailto:theark.cok@gmail.com" className="hover:text-[#FAF7F2] transition-colors" data-id="element-68">
                  theark.cok@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* CTA Column */}
          <div data-id="element-69">
            <h3 className="font-serif text-lg font-medium mb-6 text-[#D4AF37]" data-id="element-70">
              Book Your Stay
            </h3>
            <p className="text-[#FAF7F2]/70 text-sm mb-6" data-id="element-71">
              Reserve your perfect Kochi home on Airbnb or reach out directly.
            </p>
            <div className="space-y-3" data-id="element-72">
              <a href="https://airbnb.co.in/h/fortkochin" target="_blank" rel="noopener noreferrer" data-id="element-73">
                <Button className="w-full bg-[#FF385C] hover:bg-[#E31C5F] text-white border-none" data-id="element-74">
                  <svg className="h-4 w-4 mr-2" viewBox="0 0 24 24" fill="currentColor" data-id="element-75">
                    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10z" data-id="element-76" />
                    <path d="M12 6c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm0 10c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" data-id="element-77" />
                  </svg>
                  Book on Airbnb
                </Button>
              </a>
              <a href="https://wa.me/919746603446" target="_blank" rel="noopener noreferrer" data-id="element-78">
                <Button className="w-full bg-[#25D366] hover:bg-[#128C7E] text-white border-none" data-id="element-79">
                  <MessageCircle className="mr-2 h-4 w-4" data-id="element-80" />
                  Chat on WhatsApp
                </Button>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#FAF7F2]/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-81">
          <p className="text-[#FAF7F2]/50 text-xs" data-id="element-82">
            © {new Date().getFullYear()} Oshara Collective. All rights
            reserved.
          </p>
          <div className="flex space-x-6" data-id="element-83">
            <a href="#" className="text-[#FAF7F2]/50 hover:text-[#FAF7F2] text-xs" data-id="element-84">
              Privacy Policy
            </a>
            <a href="#" className="text-[#FAF7F2]/50 hover:text-[#FAF7F2] text-xs" data-id="element-85">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}